export default __webpack_public_path__ + "static/media/image-from-above.b7b9dba0.jpg";